import React, { createContext, useContext, useMemo } from "react";
import usePermissionsHook from "./permissionsHook";

type PermissionsContextType = ReturnType<typeof usePermissionsHook>;
const PermissionsContext = createContext<PermissionsContextType | null>(null);

export const PermissionsProvider: React.FC<React.PropsWithChildren<{userId: string, token: string}>> = ({ children, userId, token }) => {
  const permissions = usePermissionsHook(userId, token);
  
  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) throw new Error("usePermissions must be used within a PermissionsProvider");
  return context;
};